import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { ArrowCircleDown, AttachFile } from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { IAudition } from '../../types/global/helper';
import { useDispatchPromise } from '../../utils/AppUtils';
import { downloadProject } from '../../redux/project/actions';
import { ThemeStyle } from '../../module/ThemeManager';

const FileDownloadItem = ({ onClick, title }: { onClick?: VoidFunction; title: string; themeStyle?: ThemeStyle }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Box
            display="flex"
            onClick={onClick}
            alignItems="center"
            gap={2}
            p={2}
            sx={{
                backgroundColor: theme[themeStyle].gray_text,
                borderRadius: 2,
                width: '300px',
                cursor: 'pointer',
            }}>
            {/* PDF Icon */}
            <PictureAsPdfIcon sx={{ fontSize: 40, color: '#d32f2f' }} />

            {/* File Info */}
            <Box flex={1}>
                <Typography
                    variant="body1"
                    style={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, color: theme[themeStyle].tag_white }}
                    fontWeight="bold">
                    {title}.pdf
                </Typography>
                <Typography
                    variant="body2"
                    style={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, color: theme[themeStyle].tag_white }}
                    color="textSecondary">
                    Audition asset
                </Typography>
            </Box>
            <ArrowCircleDown sx={{ fontSize: 20, color: theme[themeStyle].tag_white }} />
        </Box>
    );
};

export interface IAttachment {
    audition: IAudition;
}

const AttachmentRenderer: React.FC<IAttachment> = ({ audition }) => {
    const { attachment, title } = audition;
    const { themeStyle } = useThemeContext();
    const dispatch = useDispatchPromise();

    const handleDownloadClick = async () => {
        if (attachment) {
            const response: any = await dispatch(downloadProject(attachment));
            const blob = await response.blob();
            const anchor = document.createElement('a');
            anchor.href = window.URL.createObjectURL(blob);
            anchor.download = `${title}.pdf`;
            anchor.click();
        }
    };

    if (!attachment) return <div />;

    return (
        <Container disableGutters>
            <Stack direction="row" gap={1} mb={2} mt={2}>
                <AttachFile
                    sx={{
                        color: theme[themeStyle].tag_white,
                    }}
                />
                <Typography
                    style={{
                        fontWeight: 'bold',
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        fontSize: 18,
                        color: theme[themeStyle].tag_white,
                    }}>
                    Attachments
                </Typography>
            </Stack>
            <Stack>
                <FileDownloadItem title={title} onClick={handleDownloadClick} themeStyle={themeStyle} />
            </Stack>
        </Container>
    );
};

export default AttachmentRenderer;
